export const FETCH_APPROACHES_REQUEST = "FETCH_APPROACHES_REQUEST";
export const FETCH_APPROACHE_BY_ID_REQUEST = "FETCH_APPROACHE_BY_ID_REQUEST";
export const UPDATE_APPROACH_REQUEST = "UPDATE_APPROACH_REQUEST";
export const CREATE_APPROACH_REQUEST = "CREATE_APPROACH_REQUEST";
export const CHANGE_APPROACH_WEIGHT_REQUEST = "CHANGE_APPROACH_WEIGHT_REQUEST";
export const DELETE_APPROACH_REQUEST = "DELETE_APPROACH_REQUEST";
